/* PawLi — upload options modal (window.openUploadOptions).
   3 sources (Files / Take photo / Photo library) working across devices/OS.
   On selection: store the photo as base64 in sessionStorage, then go to the product page. */
(function () {
  const STORAGE_KEY = 'pawli_photo';
  const PRODUCT_URL = (window.PAWLI_PRODUCT_URL || '/products/custom-pillow');

  const T = {
    title: 'Foto auswählen',
    files: 'Dateien',
    filesSub: 'Wähle ein Foto aus deinen Dateien',
    camera: 'Foto aufnehmen',
    cameraSub: 'Öffne die Kamera',
    library: 'Fotothek',
    librarySub: 'Aus deiner Galerie wählen',
    close: 'Schließen',
    tooLarge: 'Das Foto ist zu groß. Bitte wähle ein kleineres Bild.',
    readError: 'Foto konnte nicht gelesen werden. Bitte versuche ein anderes.',
  };

  let styleInjected = false;
  function injectStyles() {
    if (styleInjected) return;
    styleInjected = true;
    const css = `
      .pawli-uo { position: fixed; inset: 0; z-index: 1100; display: none; align-items: flex-end; justify-content: center; background: rgba(0,0,0,.55); }
      .pawli-uo.is-open { display: flex; }
      .pawli-uo__sheet { width: 100%; max-width: 460px; background: #fff; border-radius: 18px 18px 0 0; padding: 20px 18px calc(18px + env(safe-area-inset-bottom)); font-family: var(--pawli-font-body, sans-serif); color: #1a1a1a; }
      .pawli-uo__head { display: flex; align-items: center; justify-content: space-between; margin-bottom: 14px; }
      .pawli-uo__title { font-family: var(--pawli-font-heading, serif); font-size: 1.25rem; font-weight: 700; margin: 0; }
      .pawli-uo__x { width: 40px; height: 40px; border: none; background: #f1ece5; border-radius: 50%; font-size: 20px; cursor: pointer; }
      .pawli-uo__opt { display: flex; align-items: center; gap: 14px; width: 100%; text-align: left; background: #f8f5f0; border: 1px solid #ece5db; border-radius: 12px; padding: 14px; margin-bottom: 10px; cursor: pointer; min-height: 64px; }
      .pawli-uo__opt:active { transform: translateY(1px); }
      .pawli-uo__ic { flex: 0 0 auto; width: 44px; height: 44px; border-radius: 50%; background: rgba(232,184,75,.18); display: flex; align-items: center; justify-content: center; }
      .pawli-uo__ic svg { width: 22px; height: 22px; color: #b8860b; }
      .pawli-uo__t { display: block; font-weight: 600; margin: 0; }
      .pawli-uo__s { display: block; font-size: .82rem; opacity: .7; margin: 6px 0 0; }
      @media (min-width: 600px) { .pawli-uo { align-items: center; } .pawli-uo__sheet { border-radius: 18px; } }
    `;
    const el = document.createElement('style');
    el.textContent = css;
    document.head.appendChild(el);
  }

  let modal, fileInput;
  function ensureModal() {
    if (modal) return;
    injectStyles();
    modal = document.createElement('div');
    modal.className = 'pawli-uo';
    modal.innerHTML =
      '<div class="pawli-uo__sheet" role="dialog" aria-label="' + T.title + '">' +
        '<div class="pawli-uo__head"><h2 class="pawli-uo__title">' + T.title + '</h2>' +
        '<button type="button" class="pawli-uo__x" aria-label="' + T.close + '">&times;</button></div>' +
        '<button type="button" class="pawli-uo__opt" data-src="files">' +
          '<span class="pawli-uo__ic"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><path d="M4 4h6l2 2h8v12H4z"/></svg></span>' +
          '<span><span class="pawli-uo__t">' + T.files + '</span><span class="pawli-uo__s">' + T.filesSub + '</span></span>' +
        '</button>' +
        '<button type="button" class="pawli-uo__opt" data-src="camera">' +
          '<span class="pawli-uo__ic"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><path d="M3 7h4l2-2h6l2 2h4v12H3z"/><circle cx="12" cy="13" r="3.5"/></svg></span>' +
          '<span><span class="pawli-uo__t">' + T.camera + '</span><span class="pawli-uo__s">' + T.cameraSub + '</span></span>' +
        '</button>' +
        '<button type="button" class="pawli-uo__opt" data-src="library">' +
          '<span class="pawli-uo__ic"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><rect x="3" y="3" width="18" height="18" rx="2"/><circle cx="8.5" cy="8.5" r="1.8"/><path d="m21 15-5-5L5 21"/></svg></span>' +
          '<span><span class="pawli-uo__t">' + T.library + '</span><span class="pawli-uo__s">' + T.librarySub + '</span></span>' +
        '</button>' +
      '</div>';
    document.body.appendChild(modal);

    fileInput = document.createElement('input');
    fileInput.type = 'file';
    fileInput.accept = 'image/*';
    fileInput.style.display = 'none';
    fileInput.addEventListener('change', onFile);
    document.body.appendChild(fileInput);

    modal.querySelector('.pawli-uo__x').addEventListener('click', close);
    modal.addEventListener('click', (e) => { if (e.target === modal) close(); });
    modal.querySelectorAll('.pawli-uo__opt').forEach((btn) => {
      btn.addEventListener('click', () => pick(btn.dataset.src));
    });
  }

  function pick(src) {
    if (src === 'camera') fileInput.setAttribute('capture', 'environment');
    else fileInput.removeAttribute('capture');
    fileInput.value = '';
    fileInput.click();
  }

  function onFile(e) {
    const file = e.target.files && e.target.files[0];
    e.target.value = ''; // (1) reset l'input : permet de re-choisir même le MÊME fichier
    if (!file) return;
    const reader = new FileReader();
    reader.onload = () => {
      close();
      // (2) libère l'ancien cut-out AVANT d'écrire : le re-upload ne bute plus sur le quota
      try { sessionStorage.removeItem('pawli_cutout'); } catch (err) {}
      // (3) stocke la nouvelle photo ; si le quota est plein, on continue quand même en mémoire
      try { sessionStorage.setItem(STORAGE_KEY, reader.result); } catch (err) {}
      if (window.pawliOnNewPhoto) window.pawliOnNewPhoto(reader.result);
      else window.location.href = PRODUCT_URL;
    };
    reader.onerror = () => alert(T.readError);
    reader.readAsDataURL(file);
  }

  function open() { ensureModal(); modal.classList.add('is-open'); document.documentElement.style.overflow = 'hidden'; if (window.pawliPreloadBgRemoval) window.pawliPreloadBgRemoval(); }
  function close() { if (modal) modal.classList.remove('is-open'); document.documentElement.style.overflow = ''; }

  window.openUploadOptions = open;

  document.addEventListener('click', (e) => {
    const trigger = e.target.closest('[data-pawli-open-upload]');
    if (trigger) { e.preventDefault(); open(); }
  });
})();
